import React from 'react'
import { get } from './fetch'

// export const If = props => console.log(props.condition) || props.condition && <React.Fragment>{props.children}</React.Fragment> || null

export class If extends React.PureComponent {
    render() {
        const { props } = this
        // return null
        if (typeof props.true !== 'undefined') {
            return (!!props.true && props.children) || null
        }
        if (typeof props.test !== 'undefined') {
            return null
        }
        if (typeof props.condition !== 'undefined') {
            return (!!props.condition && props.children) || null
        }
        if (typeof props.value !== 'undefined') {
            switch (true) {
                case typeof props.gt !== 'undefined':
                    return (typeof props.gt !== 'undefined' && props.value > props.gt && props.children) || null
                case typeof props.lt !== 'undefined':
                    return (typeof props.lt !== 'undefined' && props.value < props.lt && props.children) || null
                case typeof props.gte !== 'undefined':
                    return (typeof props.gte !== 'undefined' && props.value < props.gte && props.children) || null
                case typeof props.lte !== 'undefined':
                    return (typeof props.lte !== 'undefined' && props.value < props.lte && props.children) || null
                default:
                    console.error('Invalid props for <If /> component', { props })
                    return props.children
            }
        }
        console.error('Invalid props for <If /> component', { props })
        return null
    }
}

export const withData = (query_param) => (Component) =>
    class WithData extends React.PureComponent {
        state = { data: null, prop_name: 'data' }

        componentDidMount() {
            const { query, prop_name = this.state.prop_name } = query_param
            get(query)
                // .then(r => r.json())
                .then((r) => this.setState({ data: r, prop_name }))
        }

        render() {
            const props = { [this.state.prop_name]: this.state.data }
            return <Component {...this.props} {...props} />
        }
    }

export const ensureArray = (item) => (Array.isArray(item) && item) || [item].filter(Boolean)

export function debounce(func, wait, immediate) {
    var timeout
    return function () {
        var context = this,
            args = arguments
        var later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        var callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

const dont_end_with = ['.']
export const urlText = (str) => {
    let candidate = str
        .replace(/[ \.]/g, '-')
        .normalize('NFD')
        .replace(/[^a-zA-Z0-9-]/g, '')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/--/g, '-')
    if (dont_end_with.includes(candidate.substring(candidate.length - 1))) {
        candidate = candidate.substring(0, candidate.length - 1)
    }
    return candidate
}
